import { useDecision } from '@optimizely/react-sdk';
import { ff_credentialPassportCred } from 'app/constants/FeatureFlags/Placement/Keys';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { LANDSGTGTab } from '../LANDSGTGTab/LANDSGTGTab';
import { PassportCredentialTab } from '../PassportCredentialTab/PassportCredentialTab';
import { ff_ui_candidate_Credentialing_One } from 'app/constants/FeatureFlags/Candidate/Keys';
import { CredentialingOneTab } from '../CredentialingOneTab/CredentialingOneTab';
import { userRoles } from 'oidc/userRoles';
import { Authorized } from 'oidc/userHelper';
import { useSelector } from 'react-redux';
import { selectUser } from 'oidc/user.selectors';
import { GenericTabs, Orientations } from '@AMIEWEB/Common/Tabs/GenericTabs';

export const CredentialingTabWrapper = () => {
  const [decCredentialPassportCred] = useDecision(ff_credentialPassportCred);
  const [showCredOneTab] = useDecision(ff_ui_candidate_Credentialing_One);
  const { t } = useTranslation();

  const { userInfo } = useSelector(selectUser);
  const [hasPermission, setHasPermission] = useState<boolean>(false);

  var tabs = [
    {
      label: t('placement.profile.tabs.credentialingTab.subTab.credentialing'),
      component: <PassportCredentialTab />,
      show: decCredentialPassportCred?.enabled,
    },
    {
      label: t('placement.profile.tabs.credentialingTab.subTab.LANDS/GTGChecklist'),
      component: <LANDSGTGTab />,
      show: true,
      disabled: !hasPermission,
    },
    {
      label: t('placement.profile.tabs.credentialingTab.subTab.CredOne'),
      component: <CredentialingOneTab />,
      show: showCredOneTab.enabled,
    },
  ];
  tabs = tabs.filter(tab => tab.show === true);
  useEffect(() => {
    setHasPermission(
      Authorized(
        [userRoles.credentialing_Leadership, userRoles.credentialing_TeamMember],
        userInfo,
      ),
    );
  }, [userInfo]);

  return <GenericTabs tabs={tabs} orientation={Orientations.vertical} />;
};
